<template>
  <div>
    <div class="sm-facet_slider">
      <div class="sm-facet__header">
        <div class="sm-facet__title">
          <span class="sm-facet__title__name">Цена, руб</span>
        </div>
        <button v-if="this.hasFilter()" @click.stop="clear()" type="button" class="sm-facet__clear">
          Очистить
        </button>
      </div>
      <div class="sm-facet-slider">
        <div class="sm-facet-slider__slot">
          <span class="sm-facet-slider__label">от</span>
          <input autocomplete="off"
                 class="sm-facet-slider__input"
                 :disabled="this.isDisabled"
                 inputmode="decimal"
                 name="min"
                 v-model.number="priceMin"
                 @change="this.handleInputMinChange"
                 type="number">
        </div>
        <div class="sm-facet-slider__divider"></div>
        <div class="sm-facet-slider__slot">
          <span class="sm-facet-slider__label">до</span>
          <input autocomplete="off"
                 class="sm-facet-slider__input"
                 :disabled="this.isDisabled"
                 inputmode="decimal"
                 name="max"
                 v-model.number="priceMax"
                 @change="this.handleInputMaxChange"
                 type="number">
        </div>
      </div>
      <vue-slider
          ref="slider"
          :min="this.sliderRange[0]"
          :max="this.sliderRange[1]"
          :disabled="this.isDisabled"
          :silent="true"
          :contained="true"
          :dragOnClick="true"
          v-model="value"
          @drag-end="handleSliderChange"
          @dragging="handleSliderDragging"
      ></vue-slider>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import {mapState, mapActions} from 'vuex';

export default {
  name: "facet-slider",
  data: function () {
    return {
      value: [0, 0], // модель для v-model слайдера
      priceMin: 0, // выбранное мин.значение
      priceMax: 0, // выбранное макс.значение
      priceRangeLocal: [0, 0] // полный диапазон цен
    };
  },
  computed: {
    ...mapState("search", ["isMobile", "priceRange", "priceSelected", "queryFilters"]),
    sliderRange: {
      get: function () {
        // полный диапазон цен для выборки
        let r = this.priceRange;
        this.priceRangeLocal = [r.min, r.max];
        return this.priceRangeLocal;
      },
      set: function (value) {}
    },
    isDisabled: function () {
      return this.sliderRange[0] === this.sliderRange[1];
    }
  },
  watch: {
    sliderRange: function (e) {
      // при изменении range сбрасываем ползунок в крайние положения range
      this.initSliderValues()
      this.$refs.slider.setValue(this.value);
    }
  },
  methods: {
    ...mapActions("search", ["addFilter", "removeFilters", "doSearch", "setPriceSelected"]),
    initSliderValues() {
      let sl = this.sliderRange;
      if((typeof this.priceSelected[0] !== 'undefined') && (this.priceSelected[0] > 0)) {
        this.value[0] = this.priceSelected[0];
      } else {
        this.value[0] = sl[0];
      }

      if((typeof this.priceSelected[1] !== 'undefined') && (this.priceSelected[1] > 0)) {
        this.value[1] = this.priceSelected[1];
      } else {
        this.value[1] = sl[1];
      }

      this.priceMin = this.value[0];
      this.priceMax = this.value[1];
    },
    handleSliderChange: function () {
      this.priceMin = this.value[0];
      this.priceMax = this.value[1];

      this.applyPriceFilter();
    },
    handleSliderDragging: function () {
    },
    handleInputMinChange: function () {
      if(this.priceMin < this.priceRangeLocal[0]) {
        this.priceMin = this.priceRangeLocal[0];
      }
      if(this.priceMin >= this.priceRangeLocal[1]) {
        this.priceMin = this.priceRangeLocal[1] - 1;
      }

      this.value[0] = this.priceMin
      this.$refs.slider.setValue(this.value);
      this.applyPriceFilter();
    },
    handleInputMaxChange: function () {
      if(this.priceMax <= this.priceRangeLocal[0]) {
        this.priceMax = this.priceRangeLocal[0] + 1;
      }
      if(this.priceMax > this.priceRangeLocal[1]) {
        this.priceMax = this.priceRangeLocal[1];
      }
      this.value[1] = this.priceMax
      this.$refs.slider.setValue(this.value);
      this.applyPriceFilter();
    },
    clear: function () {
      this.removeFilters('minPrice');
      this.removeFilters('maxPrice');

      this.initSliderValues();
      this.$refs.slider.setValue(this.value);
      this.doSearch();
    },
    hasFilter: function () {
      const f = this.queryFilters.filter(function (value) {
        return typeof value['minPrice'] !== 'undefined';
      });
      return Boolean(f.length);
    },
    applyPriceFilter() {
      // установка state.priceSelected в store, если не выбрано - ставим 0
      this.setPriceSelected({
        min: (this.value[0] === this.priceRangeLocal[0]) ? 0 : this.value[0],
        max: (this.value[1] === this.priceRangeLocal[1]) ? 0 : this.value[1]
      });
      //if(this.value[0] !== this.priceRangeLocal[0]) {
      this.addFilter({minPrice: this.value[0]});
      //}
      //if(this.value[1] !== this.priceRangeLocal[1]) {
      this.addFilter({maxPrice: this.value[1]});
      //}
      this.doSearch().then(() => {}).catch(err => { console.log(err.response.statusText) });
    }
  },
  components: {
    VueSlider
  },
  created() {
    this.initSliderValues();
  }
}
</script>